/**
 * 游戏公共弹窗
 * @author lianghua.fu
 * @date 2024-07-31 14:25:51
 */

import { user, base } from 'lib';
import room from '../../lib/room';
import React, { useEffect } from 'react';
import { UiModal, UiToast } from 'components';
import styled from 'styled-components';
import { request, messenger } from 'lib';

const Modal = styled(UiModal)`
  width: auto !important;
  height: auto !important;
  .inner {
    width: auto !important;
    height: auto !important;
    iframe {
      border: none;
    }
  }
`;

const GameModal = (props) => {
  const { onClose, gameInfo } = props;

  const { name, title, url, extensionsH5 } = gameInfo;

  let { width, height } = extensionsH5;

  width = width % 2 === 0 ? width : width + 1;
  height = height % 2 === 0 ? height : height + 1;

  const gameUrl =
    url +
    (url.indexOf('?') > 0 ? '&' : '?') +
    'room_id=' +
    room.getRoomId() +
    `&access_token=${user.getToken()}`;

  useEffect(() => {
    messenger.addTarget(
      document.getElementById(name).contentWindow,
      'child-h5',
      () => {},
    );

    return () => {
      messenger.removeTarget('child-h5');
    };
  }, []);

  return (
    <Modal
      onClose={onClose}
      moveEnable
      maskEnable={false}
      title={title}
      isH5Popup
      bodyStyle={{ padding: 0 }}
    >
      <div style={{ height: `${height}px`, width: `${width}px` }}>
        <iframe
          style={{ height: `${height}px`, width: `${width}px` }}
          id={name}
          src={gameUrl}
        ></iframe>
      </div>
    </Modal>
  );
};

export default GameModal;
